import { type RefObject, useEffect } from 'react';

const BOTTOM_OFFSET = 8;

/**
 * Сдвигает баннер вверх на высоту баннера + BOTTOM_OFFSET
 * @param bannerRef - ссылка на баннер
 */
export const useBannerShift = (bannerRef: RefObject<HTMLDivElement>): void => {
  useEffect(() => {
    const banner = bannerRef.current;

    if (!banner) {
      return;
    }

    const { height } = banner.getBoundingClientRect();

    banner.style.marginTop = `-${height + BOTTOM_OFFSET}px`;
  }, [bannerRef]);
};
